"use client"

import { useState, useEffect } from "react";
import "./Projects.css";
import Strive from "./images/strive.png";
import FaceRecon from "./images/yacsaf.PNG";
import JNF from "./images/jnf.png";
import UDC from "./images/udc.png";
import fses from "./images/fses.jpg";

const Projects = () => {
  const [projects, setProjects] = useState([])
  const [filter, setFilter] = useState("all")
  const [isLoading, setIsLoading] = useState(true)

  // Sample project data - in a real app, you might fetch this from an API
  useEffect(() => {
    // Simulate loading data
    setTimeout(() => {
      setProjects([
        {
          id: 1,
          title: "Strive For A+ - Online Tuition Platform",
          description:
            "A full-featured tuition platform that bridges the gap between students and qualified tutors.",
          image: `${Strive}`,
          category: "web",
          technologies: ["PHP Laravel", "MySQL"],
          demoLink: "#",
          codeLink: "https://github.com/safwen-aichy/strive-for-a-plus",
        },
        {
          id: 2,
          title: "JN Freight - Logistics Services",
          description:
            "JN Freight is a full-stack web application that streamlines logistics operations by offering real-time order tracking, customer management, and administrative tools",
          image: `${JNF}`,
          category: "web",
          technologies: ["React", "Node.JS", "Express", "MySQL"],
          demoLink: "#",
          codeLink: "https://github.com/safwen-aichy/jnf",
        },
        {
          id: 3,
          title: "Face Recon - IoT Solution",
          description:
            "An IoT solution for personnel identification using Microsoft Azure cloud services and facial recognition.",
          image: `${FaceRecon}`,
          category: "iot",
          technologies: ["Python", "OpenCV", "Azure IoT", "Azure Cloud", "Azure Functions"],
          demoLink: "#",
          codeLink: "https://github.com/safwen-aichy/faceid",
        },
        {
          id: 4,
          title: "FSES - Final Stage Evaluation System",
          description: "A web application for managing and evaluating final stage projects in an academic setting.",
          image: `${fses}`,
          category: "web",
          technologies: ["Django", "React", "PostgreSQL"],
          demoLink: "#",
          codeLink: "https://github.com/Bugless-Minds",
        },
        {
          id: 5,
          title: "Utopia Democratic Community",
          description: "A multiplayer Game Mode for Multi Theft Auto San Andreas, providing a comprehensive ecosystem including: Secure authentication system Economy and banking systems, Jobs and employment framework, Factions and grouping system, Vehicle, weapon, and item management, Turfing and gang wars, Resource trading and crafting systems, Phone system..",
          image: `${UDC}`,
          category: "other",
          technologies: ["Lua", "MySQL", "JavaScript", "HTML", "CSS"],
          demoLink: "#",
          codeLink: "https://github.com/safwen-aichy/UDC",
        },
      ])
      setIsLoading(false)
    }, 1000)
  }, [])

  const filteredProjects = filter === "all" ? projects : projects.filter((project) => project.category === filter)

  return (
    <div className="projects-container">
      <div className="projects-header">
        <h1>My Projects</h1>
        <p>A collection of my work and personal projects</p>

        <div className="filter-controls">
          <button className={`filter-btn ${filter === "all" ? "active" : ""}`} onClick={() => setFilter("all")}>
            All
          </button>
          <button className={`filter-btn ${filter === "web" ? "active" : ""}`} onClick={() => setFilter("web")}>
            Web
          </button>
          <button className={`filter-btn ${filter === "mobile" ? "active" : ""}`} onClick={() => setFilter("iot")}>
            IoT
          </button>
          <button className={`filter-btn ${filter === "ai" ? "active" : ""}`} onClick={() => setFilter("other")}>
            Other
          </button>
        </div>
      </div>

      {isLoading ? (
        <div className="loading-projects">
          <div className="loading-spinner"></div>
          <p>Loading projects...</p>
        </div>
      ) : (
        <div className="projects-grid">
          {filteredProjects.map((project) => (
            <div className="project-card" key={project.id}>
              <div className="project-image">
                <img src={project.image || "./images/strive.png"} alt={project.title} />
                <div className="project-links">
                  <a href={project.demoLink} className="project-link" target="_blank" rel="noopener noreferrer">
                    <i className="fas fa-external-link-alt"></i> Demo
                  </a>
                  <a href={project.codeLink} className="project-link" target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-github"></i> Code
                  </a>
                </div>
              </div>
              <div className="project-info">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="project-tech">
                  {project.technologies.map((tech, index) => (
                    <span key={index}>{tech}</span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Projects
